{
  "chat": {
    "title": "DreamBot",
    "subtitle": "Conseiller Sommeil IA",
    "placeholder": "Posez des questions sur le sommeil, la douleur ou les produits...",
    "send": "Envoyer le message",
    "restart": "Redémarrer le Chat",
    "close": "Fermer le chat",
    "toggleTheme": "Changer le thème",
    "typing": "DreamBot écrit...",
    "error": {
      "generic": "Quelque chose s'est mal passé. Veuillez réessayer.",
      "network": "Erreur réseau. Vérifiez votre connexion.",
      "timeout": "Délai d'attente dépassé. Veuillez réessayer.",
      "retry": "Réessayer"
    }
  },
  "greeting": {
    "welcome": "Bienvenue chez Mattress Unboxed ! Je suis DreamBot. Pour trouver votre configuration de sommeil parfaite, dites-moi : comment dormez-vous habituellement ?",
    "continueConversation": "Bon retour !",
    "continueDescription": "Souhaitez-vous continuer là où vous vous êtes arrêté ou commencer une nouvelle conversation ?",
    "continueButton": "Continuer la conversation",
    "startNewButton": "Recommencer"
  },
  "quiz": {
    "sleepPosition": {
      "question": "Comment dormez-vous habituellement ?",
      "side": "Sur le Côté",
      "back": "Sur le Dos",
      "stomach": "Sur le Ventre",
      "combination": "Combinaison"
    },
    "painPoints": {
      "question": "Ressentez-vous un inconfort spécifique au réveil ?",
      "lowerBack": "Douleur Lombaire",
      "shoulder": "Douleur à l'Épaule",
      "hot": "Trop Chaud",
      "none": "Aucune Douleur"
    },
    "firmness": {
      "question": "En termes de sensation, que préférez-vous généralement ?",
      "soft": "Doux comme un Nuage",
      "medium": "Moyen Parfait",
      "firm": "Ferme et Soutenant"
    },
    "budget": {
      "question": "Quel est votre budget approximatif ?",
      "under1000": "Moins de 1000$",
      "standard": "1000$ - 1600$",
      "luxury": "Le prix n'est pas un problème"
    },
    "bedSize": {
      "question": "Quelle taille de lit recherchez-vous ?",
      "twin": "Simple",
      "twinXL": "Simple XL",
      "full": "Double",
      "queen": "Queen",
      "king": "King",
      "calKing": "Cal King"
    }
  },
  "recommendations": {
    "analyzing": "Analyse de votre profil de sommeil...",
    "bestMatch": "Meilleure correspondance globale :",
    "alternative": "Alternative solide :",
    "anotherOption": "Autre excellente option :",
    "viewDetails": "Voir les détails",
    "warranty": "Demander la Garantie",
    "shipping": "Info Livraison",
    "startOver": "Recommencer"
  },
  "suggestions": {
    "quickStarts": "Démarrages rapides",
    "findPerfect": "Aidez-moi à trouver le matelas parfait",
    "whatSpecial": "Qu'est-ce qui rend vos matelas spéciaux ?",
    "bestSellers": "Parlez-moi de vos meilleures ventes",
    "backPain": "J'ai besoin d'aide pour les maux de dos"
  },
  "accessibility": {
    "inputDescription": "Tapez votre message et appuyez sur Entrée pour envoyer",
    "liveRegion": "DreamBot dit : {{message}}",
    "quickReplyGroup": "Options de réponse rapide",
    "quickReply": "Réponse rapide : {{label}}",
    "closeInstruction": "Fermer le chat (Ctrl+K ou glisser vers le bas)",
    "zoomInstruction": "Faire défiler pour zoomer • Cliquer et faire glisser pour déplacer"
  }
}
